<template>
  <div class="controls">
    <div class="controls_tabs_block"></div>
    <div class="controls_buttons_block">
      <!-- <div class="likes">
                <span class="like"><i class="mdi mdi-thumb-up"></i> 9999</span>
                <span class="dislike"><i class="mdi mdi-thumb-down"></i> 9999</span>
            </div> -->
      <div class="direction_buttons">
        <button class="controls_button back_button" @click="$emit('backStage')" v-if="show">Предыдущий урок</button>
        <button class="controls_button next_button" @click="$emit('nextStage')">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    buttonText: {
      default: () => 'Следующий урок',
      type: String
    },
    show: {
      default: () => true,
      type: Boolean
    }
  }
}
</script>
